import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import { useState } from "react";
import { monthData, yearData } from "../../lib/const/yearAndMonth";
import { useCommonDataContext } from "../../context/CommonDataProvider";
import extractProductsFields from "../../serviceFunctions/data_for_percentcontribution";
import { useNavigate } from "react-router-dom";
// import { autoCompleteStyle,autoCompleteTextFieldStyle ,selectFieldStyle} from '../styles/MaterialUiComponentsStyles';
import { autoCompleteStyle,autoCompleteTextFieldStyle } from "../../styles/MaterialUiComponentsStyles";


function createColumns(headers){
  const columns =  headers.map(header =>({
    field:header,
    headerName:header,
    width:400,
  }))
  columns.unshift({field:'repName',headerName:'Rep Name',width:400})
  return columns;
}


export default function AutoCompleteAllCampaign({
  setSearchData,
  setPeriod,
  setTableLoading,
  setRawData,
  selectedCampaign,
  setCreatedCols

}) {
  const [data, setData] = useState({
    startYear: null,
    startMonth: null,
    endMonth: null,
    endYear: null,
  });

  const navigate = useNavigate();
  const { availableYears } = useCommonDataContext();

  const handleFieldChange = (field, newValue) => {
    setData({ ...data, [field]: newValue ? newValue.value : "" });
  };

  const fetchData = async (data) => {

    const userDetails = JSON.parse(localStorage.getItem('token'));
    let token = userDetails ? userDetails.result.token : null;

    let url = `${process.env.REACT_APP_SERVER_BASE_URL}/transactionreports/rep/product/${selectedCampaign}?startyear=${data.startYear}&endyear=${data.endYear}&startingmonth=${data.startMonth}&endingmonth=${data.endMonth}`;
    try {
      setSearchData([]);
      setTableLoading(true);

      const response = await fetch(url, { method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      } });
      if (response.status === 401) {
        alert('Session Expired, Please login again');
        localStorage.removeItem('token');
        navigate('/login');
        setTableLoading(false)
      }
      if(response.status === 404){
        setTableLoading(false)
        return alert('No data found')
      }
      if (response.ok) {
        const jsonData = await response.json();
        // setRawData(jsonData)
        // const modifiedData = extractProductsFields(jsonData);
        const cols = createColumns(jsonData.headers);
            setCreatedCols(cols);
        setSearchData(jsonData.data);
        setTableLoading(false)


      }
    } catch (error) {
      setTableLoading(false)

      console.error("Error fetching data:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPeriod(data)
    fetchData(data);
  };

  return (
    <div className=" w-full">
      <form
        className="flex justify-between items-center w-full "
        onSubmit={handleSubmit}
      >
        <Autocomplete
        
          disablePortal
          id="startyear"
          options={availableYears}
          // value={period.startYear ? period.startYear  : null}
          sx={autoCompleteStyle}
          onChange={(event, newValue) =>
            handleFieldChange("startYear", newValue)
          }
          renderInput={(params) => <TextField {...params} label="Start Year" sx={autoCompleteTextFieldStyle} required />}
        />
        <Autocomplete
          disablePortal
          id="startMonth"
          options={monthData}
          // value={period.startMonth ? period.startMonth  : null}
          sx={autoCompleteStyle}
          onChange={(event, newValue) =>
            handleFieldChange("startMonth", newValue)
          }
          renderInput={(params) => (
            <TextField {...params} label="Start Month" sx={autoCompleteTextFieldStyle} required />
          )}
        />
        <Autocomplete
          disablePortal
          id="endYear"
          options={availableYears}
          // value={period.endYear ? period.endYear  : null}

          sx={autoCompleteStyle}
          onChange={(event, newValue) =>
            handleFieldChange("endYear", newValue)
          }
          renderInput={(params) => <TextField {...params} label="End Year" sx={autoCompleteTextFieldStyle} required/>}
        />
        <Autocomplete
          disablePortal
          id="endMonth"
          options={monthData}
          // value={period.endMonth ? period.endMonth  : null}

          sx={autoCompleteStyle}
          onChange={(event, newValue) =>
            handleFieldChange("endMonth", newValue)
          }
          renderInput={(params) => <TextField {...params} label="End Month" sx={autoCompleteTextFieldStyle} required/>}
        />

        <Button
          variant="contained"
          sx={{
            borderRadius: "20px",
            backgroundColor: "var(--color-button)",
            "&:hover": {
              backgroundColor: "var(--color-button-hover)",
            },
          }}
          type="submit"
        >
          Submit
        </Button>
      </form>
    </div>
  );
}
